import { GET_NOTIFICATION, GET_NOTIFICATION_FAIL, GET_NOTIFICATION_LOADING, GET_NOTIFICATION_SUCCESS, GET_SETTINGS, GET_SETTINGS_FAIL, GET_SETTINGS_LOADING, GET_SETTINGS_SUCCESS, SETTINGS_UPDATE, SETTINGS_UPDATE_FAIL, SETTINGS_UPDATE_LOADING, SETTINGS_UPDATE_SUCCESS } from "./actionType"

//update settings
export const settingsUpdate = (data, dispatch, getSettings, setDisabled) => {
  return {
    type: SETTINGS_UPDATE,
    payload: { data, dispatch, getSettings, setDisabled }
  }
}
export const settingsUpdateSuccess = data => {
  return {
    type: SETTINGS_UPDATE_SUCCESS,
    payload: data,
  }
}
export const settingsUpdateError = error => {
  return {
    type: SETTINGS_UPDATE_FAIL,
    payload: error
  }
}
export const settingsUpdateLoading = (loading) => {
  return {
    type: SETTINGS_UPDATE_LOADING,
    payload: loading
  }
}

//get settings
export const getSettings = () => {
  return {
    type: GET_SETTINGS
  }
}
export const getSettingsSuccess = data => {
  return {
    type: GET_SETTINGS_SUCCESS,
    payload: data,
  }
}
export const getSettingsError = error => {
  return {
    type: GET_SETTINGS_FAIL,
    payload: error
  }
}
export const getSettingsLoading = (loading) => {
  return {
    type: GET_SETTINGS_LOADING,
    payload: loading
  }
}


//get Notification
export const getNotification = () => { 
  return {
    type: GET_NOTIFICATION
  }
}
export const getNotificationSuccess = (data) => {
  return {
    type: GET_NOTIFICATION_SUCCESS,
    payload: data,
  }
}
export const getNotificationError = (error) => {
  return {
    type: GET_NOTIFICATION_FAIL,
    payload: error
  }
}
export const getNotificationLoading = (loading) => {
  return {
    type: GET_NOTIFICATION_LOADING,
    payload: loading
  }
}